// Libs
import React, { HTMLProps, ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './content-card-body.module.scss';

/**
 * Body for content card
 * Designed to be used after content card header
 * @param props the props
 */
const ContentCardBody = (props: HTMLProps<HTMLDivElement>): ReactElement => (
  <div {...props} className={clsx(styles.container, props.className)} />
);

export default ContentCardBody;
